<template>
    <div class="docs-wrapper">
        <div class="docs-table-wrapper">
          <table class="docs-table">
            <thead>
              <tr class="docs-table-row">
                <td class="docs-table-main-title" colspan="2"><span>{{ title || 'Attached documents' }}</span></td>
                <td class="docs-mode">
                  <span class="docs-mode-wrapper">
                    <span>{{ layoutLabel || 'Layout view' }}</span>
                    <a class="alcomet" :class="{ 'docs-mode-active' : isList}" @click="isList = true">x</a>
                    <a class="alcomet" :class="{ 'docs-mode-active' : !isList}" @click="isList = false">J</a>
                  </span>
                </td>
              </tr>
            </thead>
            <tbody v-if="isList">
              <tr class="docs-table-row" v-for="(doc, index) in docs" :key="'doc-' + index" @click="getDoc(doc.file)">
                <td class="docs-table-title" colspan="2">
                    <a class="docs-table-link">
                        <span class="alcomet docs-table-pdf">u</span>
                        <span class="docs-table-link-text">{{doc.name}}</span>
                    </a>
                </td>
                <td class="docs-table-download">
                    <template v-if="doc.date">{{doc.date}}</template><span class="alcomet download-icon">w</span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
                <tr class="no-hover">
                    <td colspan="3">
                        <div class="docs-table-thumbnails">
                            <a :href="doc.file" target="_blank" class="docs-table-thumbnail" v-for="(doc, index) in docs" :key="'doc-' + index">
                                <img :src="doc.img" :alt="coverAlt || 'Cover'">
                                <span>{{doc.name}}</span>
                            </a>
                        </div>
                    </td>
                </tr>
            </tbody>
          </table>
        </div>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  props: ["docs", "list", "title", "layoutLabel", "coverAlt"],
  components: {
    appShareButton: ShareButton
  },
  data() {
    return {
      isList: this.list
    };
  },
  methods: {
    getDoc(url) {
      location.href = url;
    }
  },
  mounted() {
    if (this.$route.name === "DownloadCenter" && window.innerWidth < 1000) {
      this.isList = true;
    }
  }
};
</script>

<style scoped>
.docs-wrapper > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.docs-table-wrapper {
  border-radius: 6px;
  background-color: #edf2f4;
  margin: 30px auto 0;
  padding: 20px 10%;
  width: 80%;
}
.docs-table {
  border-collapse: collapse;
  margin: 0 auto;
  margin-left: -20px;
  width: calc(100% + 40px);
}
.docs-table tr,
.docs-table td {
  border-bottom: 1px solid #becddb;
  padding-bottom: 21px;
  padding-top: 21px;
}
.docs-table tbody,
.docs-table tbody tr,
.docs-table tbody td {
  max-width: 100%;
}

.docs-table-main-title {
  font-size: 24px;
  font-weight: 500;
  padding-left: 20px;
  vertical-align: middle;
  width: 85%;
}
.docs-mode {
  font-size: 16px;
  text-align: right;
  padding-right: 20px;
  width: 15%;
}
.docs-mode-wrapper {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}
.docs-mode-wrapper > span {
  color: rgba(0, 71, 133, 0.5);
  font-size: 12px;
  display: inline-flex;
  white-space: nowrap;
}
.docs-mode-wrapper > a {
  color: rgba(0, 71, 133, 0.5);
  font-weight: 500;
  margin: 4px 0 4px 10px;
}
.docs-mode .docs-mode-active {
  color: #004787;
}
.docs-table-title {
  font-size: 16px;
  font-weight: 500;
  padding-left: 20px;
  vertical-align: baseline;
  width: 78%;
}
.docs-table-link {
  align-items: center;
  display: inline-flex;
}
.docs-table-link-text {
  color: #0086ff;
  font-size: 16px;
  font-weight: 500;
  text-decoration: underline;
}
.docs-table-pdf {
  font-size: 28px;
  margin-right: 14px;
}
.docs-table-download {
  text-align: right;
  padding-right: 20px;
}
.docs-table-download > * {
  vertical-align: middle;
}
.download-icon {
  margin-left: 10px;
}
.docs-table tbody tr:hover {
  cursor: pointer;
  background-color: #d9e6eb;
}
.no-hover {
  border: 0 !important;
  cursor: default !important;
  background-color: transparent !important;
}
.no-hover > td {
  border: 0;
}
/* THUMBNAILS */
.docs-table-thumbnails {
  overflow: hidden;
  width: 100%;
  max-width: 100%;
}
.docs-table-thumbnail {
  display: inline-block;
  padding: 20px 23px 0;
  position: relative;
  min-width: 33.33%;
  max-width: 33.33%;
  flex-shrink: 0;
}
.docs-table-thumbnail::before {
  align-items: center;
  background-color: rgba(63, 135, 208, 0.89);
  border-radius: 50%;
  content: "u";
  color: #fff;
  display: flex;
  font-family: "alcomet";
  font-size: 28px;
  height: 46px;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 12%;
  width: 46px;
  z-index: 1;
}
.docs-table-thumbnail > img {
  border-radius: 6px;
  -webkit-box-shadow: 0px 24px 59px 0px rgba(51, 58, 69, 0.36);
  -moz-box-shadow: 0px 24px 59px 0px rgba(51, 58, 69, 0.36);
  box-shadow: 0px 24px 59px 0px rgba(51, 58, 69, 0.36);
  height: auto;
  object-fit: cover;
  -o-object-fit: cover;
  width: 100%;
}
.docs-table-thumbnail > span {
  display: flex;
  font-size: 16px;
  font-weight: 500;
  height: 20%;
  justify-content: center;
  padding: 20px 20px 0;
  text-align: center;
}
@media screen and (max-width: 1280px) {
  .docs-table-thumbnail {
    max-width: 50%;
    min-width: 50%;
  }
}
@media screen and (max-width: 1000px) {
  .docs-table-wrapper {
    width: calc(100% - 60px);
  }
  .docs-table-main-title {
    font-size: 18px;
  }
  .docs-table-link-text,
  .docs-table-download,
  .docs-table-thumbnail > span {
    font-size: 14px;
  }
  .docs-table-thumbnail {
    max-width: 33.33%;
    min-width: 33.33%;
  }
}
@media screen and (max-width: 600px) {
  .docs-mode-wrapper > span {
    display: none;
  }
  .docs-table-wrapper {
    padding: 20px;
  }
  .docs-table {
    margin-left: 0;
    width: 100%;
  }
  .docs-table-main-title,
  .docs-table-title {
    padding-left: 0;
  }
  .docs-mode,
  .docs-table-download {
    padding-right: 0;
  }
  .docs-table-main-title,
  .docs-mode-wrapper > a {
    font-size: 14px;
  }
  .docs-table-link-text,
  .docs-table-download,
  .docs-table-thumbnail > span {
    font-size: 12px;
  }
  .docs-table-pdf {
    font-size: 22px;
    margin-right: 10px;
  }
  .docs-table-thumbnail {
    max-width: 50%;
    min-width: 50%;
  }
  .docs-table-thumbnail::before {
    height: 40px;
    font-size: 22px;
    width: 40px;
  }
}
@media screen and (max-width: 440px) {
  .docs-table-thumbnail {
    max-width: 100%;
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Docs.vue